import React, {useEffect, useRef} from 'react';

import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../../styles/language-menu.module.scss";
import {LanguageViewModel} from "../../../../domain/locale/models/language/language.view-model";
import {LanguageMenuModuleHeaderItem} from "./language-menu-module.header-item";

export const LanguageMenuModuleHeaderItems = observer(({controller}) => {
  const ref = useRef(null);

  const {state, device} = controller;
  const {menuModel} = state;
  const {isSmallView} = device;
  const {isMenuOpen, headerItems, shouldRenderHeaderFullDisplay, shouldRenderButtonLabel} = menuModel;
  const shouldScrollIntoView: Boolean = shouldRenderButtonLabel && isMenuOpen && !isSmallView;

  useEffect(() => {
    shouldScrollIntoView && ref.current.scrollIntoView({behavior: "auto", block: "start"});
  }, [isMenuOpen])

  const headerItemsProps = {
    className: classNames(styles.header_items, {[styles.header_full_display]: shouldRenderHeaderFullDisplay}),
    ref
  }

  return (
    <div {...headerItemsProps}>
      {
        headerItems.map((language: LanguageViewModel, index) => <LanguageMenuModuleHeaderItem
            language={language}
            index={index}
            key={language.id}
            controller={controller}
          />
        )
      }
    </div>
  )
});
